import { APP_INITIALIZER,NgModule } from '@angular/core';
import {DatePipe} from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import { BsDropdownModule, BsModalService, TypeaheadModule, PaginationModule, TimepickerModule, PopoverModule} from 'ngx-bootstrap';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker'
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { TabsComponent } from './pages/tabs/tabs.component';
import { HeaderComponent } from './shared/header/header.component';
import { config } from 'process';
import { MsalGuard, MsalInterceptor, MsalModule, MsalRedirectComponent } from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { AzureAdDemoService } from './services/azure-ad-demo.service';
import { ModalModule, BsModalRef } from 'ngx-bootstrap/modal';
import { CitiesComponent } from './pages/cities/cities.component';
import { CitiesFilterComponent } from './pages/cities/cities-filter/cities-filter.component';
import { CitiesTableComponent } from './pages/cities/cities-table/cities-table.component';
import { CitiesHeaderComponent } from './pages/cities/cities-header/cities-header.component';
import { ConfirmationModalComponent } from './shared/components/confirmation-modal/confirmation-modal.component';
import { NgxSelectModule } from 'ngx-select-ex';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Injectable } from '@angular/core';
import { AddCityComponent } from './pages/cities/add-city/add-city.component';
import { EditCityComponent } from './pages/cities/edit-city/edit-city.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { OfficesHeaderComponent } from './pages/offices/offices-header/offices-header.component';
import { OfficesTableComponent } from './pages/offices/offices-table/offices-table.component';
import { OfficesComponent } from './pages/offices/offices.component';
import { AddOfficeComponent } from './pages/offices/add-office/add-office.component';
import {TooltipModule} from 'ngx-bootstrap';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { LoaderService } from './shared/services/loader.service';
import { LoaderInterceptor } from './shared/interceptors/loader.interceptor';
import { OfficesFilterComponent } from './pages/offices/offices-filter/offices-filter.component';
import { EditOfficeComponent } from './pages/offices/edit-office/edit-office.component';
import { UsersHeaderComponent } from './pages/users/users-header/users-header.component';
import { UsersTableComponent } from './pages/users/users-table/users-table.component';
import { AddUserComponent } from './pages/users/add-user/add-user.component';
import { EditUserComponent } from './pages/users/edit-user/edit-user.component';
import {environment} from '../environments/environment';
import { DataContextService } from './shared/services/data-context.service';
import { EmailConfigurationComponent } from './pages/email-configuration/email-configuration.component';
import { InwardRequestsComponent } from './pages/inward-requests/inward-requests.component';
import { InwardHeaderComponent } from './pages/inward-requests/inward-header/inward-header.component';
import { InwardTableComponent } from './pages/inward-requests/inward-table/inward-table.component';
import { InwardFilterComponent } from './pages/inward-requests/inward-filter/inward-filter.component';
import { InwardRegComponent } from './pages/inward-requests/inward-reg/inward-reg.component';
import { OutwardComponent } from './pages/outward/outward.component';
import { OutwardHeaderComponent } from './pages/outward/outward-header/outward-header.component';
import { OutwardTableComponent } from './pages/outward/outward-table/outward-table.component';
import { AddOutwardComponent } from './pages/outward/add-outward/add-outward.component';
import { OutwardFilterComponent } from './pages/outward/outward-filter/outward-filter.component';
//import { EditOutwardComponent } from './pages/outward/edit-outward/edit-outward.component';
import { ViewOutwardComponent } from './pages/outward/view-outward/view-outward.component';
import { ProgressbarComponent } from './shared/components/progressbar/progressbar.component';
import * as $ from 'jquery';
import { UploadmaterialComponent } from './shared/components/uploadmaterial/uploadmaterial.component';
import { ViewInwardComponent } from './pages/inward-requests/view-inward/view-inward.component';
import { UsersFilterComponent } from './pages/users/users-filter/users-filter.component';
import { OutwardApproverComponent } from './pages/outward-approver/outward-approver.component';
import { OutwardApproverTableComponent } from './pages/outward-approver/outward-approver-table/outward-approver-table.component';
import { OutwardApproverHeaderComponent } from './pages/outward-approver/outward-approver-header/outward-approver-header.component';
import { OutwardApproverFilterComponent } from './pages/outward-approver/outward-approver-filter/outward-approver-filter.component';
import { ApproverCommentsComponent } from './pages/outward-approver/approver-comments/approver-comments.component';
import { FilterPipe } from './shared/Pipes/filter.pipe';
import { InwardProgressBarComponent } from './pages/inward-requests/view-inward/inward-progress-bar/inward-progress-bar.component';
import { ReceivedByComponent } from './pages/inward-requests/received-by/received-by.component';
import { UploadChallanComponent } from './pages/inward-requests/upload-challan/upload-challan.component';
import { DeclinePopupComponent } from './pages/inward-requests/view-inward/decline-popup/decline-popup.component';
import { ViewOutwardApproverComponent } from './pages/outward-approver/view-outward-approver/view-outward-approver.component';
import { SmallProgressBarComponent } from './shared/components/small-progress-bar/small-progress-bar.component';
import { EditRequestComponent } from './pages/inward-requests/edit-request/edit-request.component';
import{ CancelPopupComponent } from './pages/outward/view-outward/cancel-popup/cancel-popup.component';
import { OutwardL2approverComponent } from './pages/outward-l2approver/outward-l2approver.component';
import { OutwardL2approverTableComponent } from './pages/outward-l2approver/outward-l2approver-table/outward-l2approver-table.component';
import { L2approverCommentsComponent } from './pages/outward-l2approver/l2approver-comments/l2approver-comments.component';
import { OutwardL2approverFilterComponent } from './pages/outward-l2approver/outward-l2approver-filter/outward-l2approver-filter.component';
import { OutwardL2approverHeaderComponent } from './pages/outward-l2approver/outward-l2approver-header/outward-l2approver-header.component';
import { ViewOutwardL2approverComponent } from './pages/outward-l2approver/view-outward-l2approver/view-outward-l2approver.component';
import { OutwardSupervisorComponent } from './pages/outward-supervisor/outward-supervisor.component';
import { SupervisorCommentsComponent } from './pages/outward-supervisor/supervisor-comments/supervisor-comments.component';
import { OutwardSupervisorFilterComponent } from './pages/outward-supervisor/outward-supervisor-filter/outward-supervisor-filter.component';
import { OutwardSupervisorHeaderComponent } from './pages/outward-supervisor/outward-supervisor-header/outward-supervisor-header.component';
import { OutwardSupervisorTableComponent } from './pages/outward-supervisor/outward-supervisor-table/outward-supervisor-table.component';
import { ViewOutwardSupervisorComponent } from './pages/outward-supervisor/view-outward-supervisor/view-outward-supervisor.component';
import { OutwardProgressBarComponent } from './pages/outward/view-outward/outward-progress-bar/outward-progress-bar.component';
import {AUTH_PROVIDER} from './shared/interceptors/auth-interceptor';
import {AppInitService} from './shared/services/Auth/business/app-init.service';
import { AccessDeniedComponent } from './pages/access-denied/access-denied.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AuditConfigurationComponent } from './pages/audit-trail/configuration/audit-configuration/audit-configuration.component';
//import { AuditTransactionComponent } from './pages/audit-trail/transaction/audit-transaction/audit-transaction.component';
import { AuditConfigurationHeaderComponent } from './pages/audit-trail/configuration/audit-configuration-header/audit-configuration-header.component';
//import { AuditTransactionHeaderComponent } from './pages/audit-trail/transaction/audit-transaction-header/audit-transaction-header.component';
import { AuditConfigurationFilterComponent } from './pages/audit-trail/configuration/audit-configuration-filter/audit-configuration-filter.component';
import { UserModalComponent } from './pages/users/user-modal/user-modal.component';
import { CollectMaterialComponent } from './pages/inward-requests/collect-material/collect-material.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { UploadMaterialComponent } from './pages/upload-material/upload-material.component';
import { NgxDocViewerModule } from 'ngx-doc-viewer';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    TabsComponent,
    HeaderComponent,
    CitiesComponent,
    EditCityComponent,
    CitiesFilterComponent,
    CitiesTableComponent,
    CitiesHeaderComponent,
    ConfirmationModalComponent,
    AddCityComponent,
    OfficesComponent,
    OfficesHeaderComponent,
    OfficesTableComponent,
    AddOfficeComponent,
    OutwardComponent,
    OutwardHeaderComponent,
    OutwardTableComponent,
    AddOutwardComponent,
    OutwardFilterComponent,
    //EditOutwardComponent,
    LoaderComponent,
    OfficesFilterComponent,
    EditOfficeComponent,
    UsersHeaderComponent,
    UsersTableComponent,
    AddUserComponent,
    EditUserComponent,
    EmailConfigurationComponent,
    InwardRequestsComponent,
    InwardHeaderComponent,
    InwardTableComponent,
    InwardFilterComponent,
    InwardRegComponent,
    ViewOutwardComponent,
    ProgressbarComponent,
    UploadmaterialComponent,
    UsersFilterComponent,
    ViewInwardComponent,
    UploadmaterialComponent,
    OutwardApproverComponent,
    OutwardApproverTableComponent,
    OutwardApproverHeaderComponent,
    OutwardApproverFilterComponent,
    ApproverCommentsComponent,
    FilterPipe,
    InwardProgressBarComponent,
    ReceivedByComponent,
    UploadChallanComponent,
    ApproverCommentsComponent,
    ViewOutwardApproverComponent,
    DeclinePopupComponent,
    EditRequestComponent,
    ApproverCommentsComponent,
    ViewOutwardApproverComponent,
    UploadChallanComponent,
    SmallProgressBarComponent,
    CancelPopupComponent,
    OutwardL2approverComponent,
    OutwardL2approverTableComponent,
    L2approverCommentsComponent,
    OutwardL2approverFilterComponent,
    OutwardL2approverHeaderComponent,
    ViewOutwardL2approverComponent,
    OutwardSupervisorComponent,
    SupervisorCommentsComponent,
    OutwardSupervisorFilterComponent,
    OutwardSupervisorHeaderComponent,
    OutwardSupervisorTableComponent,
    ViewOutwardSupervisorComponent,
    OutwardProgressBarComponent,
    AccessDeniedComponent,
    AuditConfigurationComponent,
    //AuditTransactionComponent,
    AuditConfigurationHeaderComponent,
    //AuditTransactionHeaderComponent,
    AuditConfigurationFilterComponent,
    UserModalComponent,
    CollectMaterialComponent,
    NotFoundComponent,
    UploadMaterialComponent,
  
   ],
    
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    NgxSelectModule,
    AppRoutingModule,
    TypeaheadModule.forRoot(),
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    HttpClientModule,
    NgxPaginationModule,
    ToastrModule.forRoot({positionClass: 'toast-bottom-center',closeButton:true,timeOut:5000,preventDuplicates:true}),
    PaginationModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TypeaheadModule.forRoot(),
    TimepickerModule.forRoot(),
    TooltipModule.forRoot(),
    PopoverModule.forRoot(),
    NgxDocViewerModule,
    NgxSpinnerModule
      
    // MsalModule.forRoot(new PublicClientApplication
    //   (
    //     {
    //       auth: {
    //         clientId: environment.clientId,
    //         // redirectUri: 'http://localhost:4444',
    //         redirectUri: environment.baseUrl,
    //         authority: `https://login.microsoftonline.com/${environment.tenant}`
    //       },
    //       cache:
    //       {
    //         cacheLocation: 'localStorage',
    //         storeAuthStateInCookie: false
    //       }
    //     }
    //   ),
    //   {
    //     interactionType: InteractionType.Redirect,
    //     authRequest: {
    //       scopes: ['user.read']
    //     }
    //   },
    //   {
    //     interactionType: InteractionType.Redirect,
    //     protectedResourceMap: new Map(
    //       [
    //         ['https://graph.microsoft.com/v1.0/me', ['user.Read']]
    //       ]
    //     )
    //   }
    // )
  ],
  providers: [
    DataContextService,
    LoaderService,
    BsModalRef,
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: MsalInterceptor,
    //   multi: true
    // }, 
    // MsalGuard, 
    AzureAdDemoService,
    BsModalService,
    { 
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor, 
      multi: true 
    },
    BsModalService,
    DatePipe,
    AUTH_PROVIDER,
    AppInitService,
    {
        provide: APP_INITIALIZER,
        useFactory: (config: AppInitService) => () => config.getSettings(),
        deps: [AppInitService],
        multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



